import { render, staticRenderFns } from "./ListAccountingRecords.vue?vue&type=template&id=0c5351e0&lang=pug&"
import script from "./ListAccountingRecords.vue?vue&type=script&lang=js&"
export * from "./ListAccountingRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListAccountingRecords.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VIcon,
})
